import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router'
import { Box, Button, Input, PasswordInput, Stack, Text } from '@n26/nxd'
import { AuthLayout } from './AuthLayout'
import { Logo } from './Logo'
import { useAuth } from './AuthContext'
import { ROUTES } from '@/shared/routes'
import styles from './LoginPage.module.css'

export const LoginPage = () => {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [hasError, setHasError] = useState(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (login(email, password)) {
      navigate(ROUTES.HOME, { replace: true })
    } else {
      setHasError(true)
    }
  }

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit} noValidate>
        <Stack direction='vertical' space='16'>
          <Logo className={styles.logo} />

          <Input
            id='email'
            name='email'
            type='email'
            autoComplete='email'
            required
            label='Email'
            value={email}
            onChange={e => {
              setEmail(e.currentTarget.value)
              setHasError(false)
            }}
          />

          <PasswordInput
            id='password'
            name='password'
            autoComplete='current-password'
            required
            label='Password'
            value={password}
            onChange={e => {
              setPassword(e.currentTarget.value)
              setHasError(false)
            }}
          />

          {hasError && (
            <Box
              id='login-errors'
              role='alert'
              padding='12'
              borderRadius='8'
              backgroundColor='rhubarb-alternate'
            >
              <Text variant='small' color='rhubarb'>
                Email or password is incorrect.
              </Text>
            </Box>
          )}

          <Button
            type='submit'
            variant='primary'
            color='teal'
            disabled={!email || !password}
          >
            Log in
          </Button>
        </Stack>
      </form>
    </AuthLayout>
  )
}
